import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Button } from "../Components/ui/button.js";
import { cn } from "../lib/utils.js";
import { ArrowDownIcon } from "lucide-react";
import { useCallback } from "react";
import { StickToBottom, useStickToBottomContext } from "use-stick-to-bottom";
const Conversation = ({ className, ...props }) => /* @__PURE__ */ jsx(
  StickToBottom,
  {
    className: cn("tw:relative tw:flex-1 tw:overflow-y-auto", className),
    initial: "smooth",
    resize: "smooth",
    role: "log",
    ...props
  }
);
const ConversationContent = ({ className, ...props }) => /* @__PURE__ */ jsx(StickToBottom.Content, { className: cn("tw:p-4", className), ...props });
const ConversationEmptyState = ({
  className,
  title = "No messages yet",
  description = "Start a conversation to see messages here",
  icon,
  children,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "tw:flex tw:size-full tw:flex-col tw:items-center tw:justify-center tw:gap-3 tw:p-8 tw:text-center",
      className
    ),
    ...props,
    children: children ?? /* @__PURE__ */ jsxs(Fragment, { children: [
      icon && /* @__PURE__ */ jsx("div", { className: "tw:text-muted-foreground", children: icon }),
      /* @__PURE__ */ jsxs("div", { className: "tw:space-y-1", children: [
        /* @__PURE__ */ jsx("h3", { className: "tw:font-medium tw:text-sm", children: title }),
        description && /* @__PURE__ */ jsx("p", { className: "tw:text-muted-foreground tw:text-sm", children: description })
      ] })
    ] })
  }
);
const ConversationScrollButton = ({ className, ...props }) => {
  const { isAtBottom, scrollToBottom } = useStickToBottomContext();
  const handleScrollToBottom = useCallback(() => {
    scrollToBottom();
  }, [scrollToBottom]);
  return !isAtBottom && /* @__PURE__ */ jsx(
    Button,
    {
      className: cn(
        "tw:absolute tw:bottom-4 tw:left-[50%] tw:translate-x-[-50%] tw:!rounded-full",
        "tw:bg-white/50 tw:backdrop-blur-md tw:border-white/30 tw:shadow-lg",
        "hover:tw:bg-white/70",
        className
      ),
      onClick: handleScrollToBottom,
      size: "icon",
      type: "button",
      variant: "outline",
      ...props,
      children: /* @__PURE__ */ jsx(ArrowDownIcon, { className: "tw:size-4 tw:text-gray-700" })
    }
  );
};
export {
  Conversation,
  ConversationContent,
  ConversationEmptyState,
  ConversationScrollButton
};
//# sourceMappingURL=conversation.js.map
